export const MAX_COMMENT_LENGTH = 255;

export const UNICODE_MDASH = '\u2014';

export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;

export const MAX_COMPANY_NAME_LENGTH = 255;

export const MAX_EMAIL_LENGTH = 254;

export const MAX_FIRST_LAST_NAME_LENGTH = 150;
